module.exports = __webpack_public_path__ + "media/images/trash_icon-1e5d190f.png";